import { cartActionTypes } from './cart.types';
import { addItemToCart, removeItemFromCart } from './cart.utils';

const INITIAL_STATE = {
    hidden: true,
    cartItems: []
}

const cartReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case cartActionTypes.SET_HIDDEN_STATE:
            return ({
                ...state,
                hidden: !state.hidden
            })
        case cartActionTypes.ADD_ITEM:
            return ({
                ...state,
                cartItems: addItemToCart(state.cartItems, action.payload)
            })
        case cartActionTypes.DELETE_ITEM_FROM_CART:
            return ({
                ...state,
                cartItems: state.cartItems.filter(cartItem => cartItem.id !== action.payload.id)
            })
        case cartActionTypes.REMOVE_ITEM:
            return ({
                ...state,
                cartItems: removeItemFromCart(state.cartItems, action.payload)
            })
        default:
            return state
    }
}

export default cartReducer;